import { createContext, useContext, useState, useCallback } from 'react';
import type { ReactNode } from 'react';

interface ReviewModeState {
  isReviewMode: boolean;
  toggleReviewMode: () => void;
}

const STORAGE_KEY = 'haamil-review-mode';

const ReviewModeContext = createContext<ReviewModeState>({
  isReviewMode: false,
  toggleReviewMode: () => {},
});

export function ReviewModeProvider({ children }: { children: ReactNode }) {
  const [isReviewMode, setIsReviewMode] = useState(
    () => localStorage.getItem(STORAGE_KEY) === 'true',
  );

  const toggleReviewMode = useCallback(() => {
    setIsReviewMode((prev) => {
      const next = !prev;
      window.localStorage.setItem(STORAGE_KEY, String(next));
      return next;
    });
  }, []);

  return (
    <ReviewModeContext value={{ isReviewMode, toggleReviewMode }}>
      {children}
    </ReviewModeContext>
  );
}

export function useReviewMode() {
  return useContext(ReviewModeContext);
}
